import { DarkMode, Help, LightMode, Logout } from '@mui/icons-material';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import React from 'react';
import { version } from './Constants';
import Popup from './Popup';
import './table.css'

const pages = ['Devices', 'Configured Devices', 'Firmware', 'Users', 'Device Hardware', 'Gateway'];

const HeaderComponent = (props) => {

  const [alignment, setAlignment] = React.useState('Devices');
  const [openErrorPopup, setOpenErrorPopup] = React.useState(false);

  const handleChange = (event, newAlignment) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
      props.loadPages(newAlignment.toUpperCase());
    }
  };


  return (
    <>
      <AppBar position="static">
        <Container maxWidth={false}>
          <Toolbar disableGutters variant='dense'>
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{
                mr: 2,
                display: { xs: 'none', md: 'flex' },
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.3rem',
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              FOTA
              <span style={{ fontSize: 12, fontWeight: 10, letterSpacing: '.01rem' }}>{version}</span>
            </Typography>
            <ToggleButtonGroup
              sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}
              value={alignment}
              exclusive
              onChange={handleChange}
              color='standard'
            >
              {pages.map((page) => (
                <ToggleButton sx={{ color: 'white', display: 'block', border: 'none', margin: 0 }} key={page} value={page}>{page}</ToggleButton>
              ))}
            </ToggleButtonGroup>
            <Box sx={{ flexGrow: 0 ,mt:1}}>
              <Tooltip title="Toggle Theme">
                <IconButton onClick={props.toggleTheme} sx={{ p: 0, color: 'white', float: 'left', display: 'block', mr: 2 }}>
                  {props.mode === "light" ? <DarkMode /> : <LightMode />}
                </IconButton>
              </Tooltip>
              <Tooltip title="Error Code">
                <IconButton sx={{ p: 0, color: 'white', float: 'left', display: 'block', mr: 2 }} onClick={() => setOpenErrorPopup(true)}>
                  <Help />
                </IconButton>
              </Tooltip>
              <Tooltip title="logout">
                <IconButton sx={{ p: 0, color: 'white', display: 'block' }} onClick={props.logOut}>
                  <Logout />
                </IconButton>
              </Tooltip>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      <Popup
        title={'Error Code Details'}
        openPopup={openErrorPopup}
        setOpenPopup={setOpenErrorPopup}
      >
        <div>
          <span>
            FOTA Success/Error Message
          </span>
          <br></br>
          <br></br>
          <span>
            <b>$,2,	&lt;FW_TYPE	&gt;,	&lt;ERROR_CODE	&gt;,#</b>
          </span>
          <br></br>
          <br></br>
          <table style={{ width: '100%' }}>
            <tbody>
              <tr>
                <td>  &lt;FW_TYPE&gt;  </td>
                <td>0 – BG96 Firmware,1-Bootloader Firmware,2-Application Firmware</td>
              </tr>
              <tr>
                <td>  &lt;ERROR_CODE&gt;  </td>
                <td>0 – Success (Other codes to be added as code progress)</td>
              </tr>
            </tbody>
          </table>
          <br></br>
          <br></br>
          <b>
            FOTA Error Codes
          </b>
          <br></br>
          <br></br>
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Error-code</th>
                <th>Error Code Name</th>
                <th>Error code details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>  0  </td>
                <td>  SUCCESS_FOTA  </td>
                <td> - </td>
              </tr>
              <tr>
                <td>  1  </td>
                <td>  ERR_PARAM_SIZE  </td>
                <td>Size of data is not within in length. Data like Firmware type, Firmware version ,URL,CRC, binary location etc.</td>
              </tr>
              <tr>
                <td>  2  </td>
                <td>  PARAM_SYNTAX_ERROR  </td>
                <td>Syntax is not proper or missing required data.</td>
              </tr>
              <tr>
                <td>  3  </td>
                <td>  TIMEOUT_IN_BL  </td>
                <td>If device is in bootloader mode and device is stuck in
                  some where and also not executing part of OTA.</td>
              </tr>
              <tr>
                <td>  4  </td>
                <td>  APN_ERROR  </td>
                <td>If string for APN setting is not proper and does not gives valid response</td>
              </tr>
              <tr>
                <td>  5  </td>
                <td>  INTERNET_CONNECT_ERROR  </td>
                <td>If IP is not received after activated PDP command.</td>
              </tr>
              <tr>
                <td>  6  </td>
                <td>  MQTT_CERT_ERROR  </td>
                <td>If Required certificate command is send and does not getting valid response.</td>
              </tr>
              <tr>
                <td>  7  </td>
                <td>  MQTT_OPEN_ERROR  </td>
                <td>If Error in sever connection open and does not received valid response.</td>
              </tr>
              <tr>
                <td>  8  </td>
                <td>  MQTT_CONNECT_ERROR  </td>
                <td>If MQTT connection AT command string not proper (i.e. wrong client ID) and does not received valid response</td>
              </tr>
              <tr>
                <td>  9  </td>
                <td>  MQTT_SUBSCRIBE_ERROR  </td>
                <td>Command send for subscribe the topic and does not received valid response.</td>
              </tr>
              <tr>
                <td>  10  </td>
                <td>  HTTPURL_ERROR  </td>
                <td>Wrong URL send.</td>
              </tr>
              <tr>
                <td>  11  </td>
                <td>  CRC_MISMATCH  </td>
                <td>When calculated CRC of OTA binary is not matched with CRC in OTA link.</td>
              </tr>
              <tr>
                <td>  12  </td>
                <td>  CREG_ERROR  </td>
                <td>Registration of sim card is not successful</td>
              </tr>
              <tr>
                <td>  13  </td>
                <td>  SSL_SETTINGS  </td>
                <td>Any SSL related AT command sent and does not received valid response.</td>
              </tr>
              <tr>
                <td>  14  </td>
                <td>  HTTP_GET_ERROR  </td>
                <td>Command send for the received the file from given URL  and if file does not received than error generated. </td>
              </tr>
              <tr>
                <td>  15 </td>
                <td>  OTHER_ERROR_RESP  </td>
                <td>Error generate other than written AT commands</td>
              </tr>
              <tr>
                <td>  16  </td>
                <td>  NORESP_AT  </td>
                <td>Specific AT command gives Error or No response</td>
              </tr>
              <tr>
                <td>  17  </td>
                <td>  NORESP_COMMANDS  </td>
                <td>Specific other than AT command gives Error or No response</td>
              </tr>
              <tr>
                <td>  18  </td>
                <td>  -  </td>
                <td>-</td>
              </tr>
              <tr>
                <td>  19  </td>
                <td>  OTHER_NO_RESP  </td>
                <td>-</td>
              </tr>
              <tr>
                <td>  20  </td>
                <td>  SHRD_MEM  </td>
                <td>-</td>
              </tr>
              <tr>
                <td>  21  </td>
                <td>  FOOTER_CRC_MISMATCH  </td>
                <td>When OTA is start, First read Footer data and calculate CRC and match with written CRC data, if both are not matched than this error generated.</td>
              </tr>
              <tr>
                <td>  22  </td>
                <td>  MCU_MISMATCH  </td>
                <td>When OTA is start, if CRC matched but MCU name is not matched than this error generated.</td>
              </tr>
              <tr>
                <td>  23  </td>
                <td>  MEM_MISMATCH  </td>
                <td>When we install binary at some particular location which is already empty than this generate error</td>
              </tr>


            </tbody>
          </table>
          <br></br>
          <br></br>
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Error Code</th>
                <th>Error code details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>  400  </td>
                <td>Invalid input value</td>
              </tr>
              <tr>
                <td>  401  </td>
                <td>Larger than the size of the file</td>
              </tr>
              <tr>
                <td>  402  </td>
                <td>Read zero byte</td>
              </tr>
              <tr>
                <td>  403  </td>
                <td>Drive full</td>
              </tr>
              <tr>
                <td>  405  </td>
                <td>File not found</td>
              </tr>
              <tr>
                <td>  406  </td>
                <td>Invalid file name</td>
              </tr>
              <tr>
                <td>  407  </td>
                <td>File already existed</td>
              </tr>
              <tr>
                <td>  409  </td>
                <td>Fail to write the file</td>
              </tr>
              <tr>
                <td>  410  </td>
                <td>Fail to open the file</td>
              </tr>
              <tr>
                <td>  411  </td>
                <td>Fail to read the file</td>
              </tr>
              <tr>
                <td>  413  </td>
                <td>Reach the max number of file allowed to be opened</td>
              </tr>
              <tr>
                <td>  414  </td>
                <td>The file read-only</td>
              </tr>
              <tr>
                <td>  416  </td>
                <td>Invalid file descriptor</td>
              </tr>
              <tr>
                <td>  417  </td>
                <td>Fail to list the file</td>
              </tr>
              <tr>
                <td>  418  </td>
                <td>Fail to delete the file</td>
              </tr>
              <tr>
                <td>  419  </td>
                <td>Fail to get disk info</td>
              </tr>
              <tr>
                <td>  420  </td>
                <td>No space</td>
              </tr>
              <tr>
                <td>  421  </td>
                <td>Time out</td>
              </tr>
              <tr>
                <td>  423  </td>
                <td>File too large</td>
              </tr>
              <tr>
                <td>  425  </td>
                <td>Invalid parameter</td>
              </tr>
              <tr>
                <td>  426 </td>
                <td>File already opened</td>
              </tr>
              <tr>
                <td>  504  </td>
                <td>Firmware upgrade failed</td>
              </tr>
              <tr>
                <td>  505  </td>
                <td>Upgrade package not exist</td>
              </tr>
              <tr>
                <td>  506  </td>
                <td>Upgrade package check failed</td>
              </tr>
              <tr>
                <td>  511  </td>
                <td>Package is mismatched with the current firmware</td>
              </tr>
              <tr>
                <td>  550  </td>
                <td>Unknown error</td>
              </tr>
              <tr>
                <td>  551  </td>
                <td>Operation blocked</td>
              </tr>
              <tr>
                <td>  552  </td>
                <td>Invalid parameter</td>
              </tr>
              <tr>
                <td>  553  </td>
                <td>Memory not enough</td>
              </tr>
              <tr>
                <td>  554  </td>
                <td>Create socket failed</td>
              </tr>
              <tr>
                <td>  555  </td>
                <td>Operation not supported</td>
              </tr>
              <tr>
                <td>  556  </td>
                <td>Socket bind failed</td>
              </tr>
              <tr>
                <td>  557  </td>
                <td>Socket listen failed</td>
              </tr>
              <tr>
                <td>  558  </td>
                <td>Socket write failed</td>
              </tr>
              <tr>
                <td>  559  </td>
                <td>Socket read failed</td>
              </tr>
              <tr>
                <td>  560  </td>
                <td>Socket accept failed</td>
              </tr>
              <tr>
                <td>  561  </td>
                <td>Open PDP context failed</td>
              </tr>
              <tr>
                <td>  562  </td>
                <td>Close PDP context failed</td>
              </tr>
              <tr>
                <td>  563  </td>
                <td>Socket identity has been used</td>
              </tr>
              <tr>
                <td>  564  </td>
                <td>  DNS busy  </td>
              </tr>
              <tr>
                <td> 565   </td>
                <td>  DNS parse failed  </td>
              </tr>
              <tr>
                <td>  566  </td>
                <td>  Socket connection failed  </td>
              </tr>
              <tr>
                <td>  567  </td>
                <td> Socket has been closed  </td>
              </tr>
              <tr>
                <td>  568  </td>
                <td>  Operation busy  </td>
              </tr>
              <tr>
                <td>   569 </td>
                <td>  Operation timeout  </td>
              </tr>
              <tr>
                <td>  570  </td>
                <td>  PDP context break down  </td>
              </tr>
              <tr>
                <td>  571  </td>
                <td> Cancel send   </td>
              </tr>
              <tr>
                <td>  572  </td>
                <td>  Operation not allowed  </td>
              </tr>
              <tr>
                <td>  573  </td>
                <td>  APN not configured  </td>
              </tr>
              <tr>
                <td>  574  </td>
                <td>  Port busy  </td>
              </tr>
              <tr>
                <td>  701  </td>
                <td>  HTTP(S) unknown error  </td>
              </tr>
              <tr>
                <td> 702   </td>
                <td>  HTTP(S) timeout  </td>
              </tr>
              <tr>
                <td>  703  </td>
                <td> HTTP(S) busy   </td>
              </tr>
              <tr>
                <td>  704  </td>
                <td>  HTTP(S) UART busy  </td>
              </tr>
              <tr>
                <td>  705  </td>
                <td>  HTTP(S) no GET/POST requests  </td>
              </tr>
              <tr>
                <td>  706  </td>
                <td>  HTTP(S) network busy  </td>
              </tr>
              <tr>
                <td>  707  </td>
                <td>  HTTP(S) network open failed  </td>
              </tr>
              <tr>
                <td>  708  </td>
                <td>  HTTP(S) network no configuration  </td>
              </tr>
              <tr>
                <td>  709  </td>
                <td>  HTTP(S) network deactivated  </td>
              </tr>
              <tr>
                <td>  710  </td>
                <td>  HTTP(S) network error  </td>
              </tr>
              <tr>
                <td>  711  </td>
                <td>  HTTP(S) URL error  </td>
              </tr>
              <tr>
                <td>  712  </td>
                <td>  HTTP(S) empty URL  </td>
              </tr>
              <tr>
                <td>  713  </td>
                <td>  HTTP(S) IP address error  </td>
              </tr>
              <tr>
                <td>  714  </td>
                <td>  HTTP(S) DNS error  </td>
              </tr>
              <tr>
                <td>  715  </td>
                <td>  HTTP(S) socket create error  </td>
              </tr>
              <tr>
                <td>  716  </td>
                <td>  HTTP(S) socket connect error  </td>
              </tr>
              <tr>
                <td>  717  </td>
                <td>  HTTP(S) socket read error  </td>
              </tr>
              <tr>
                <td>  718  </td>
                <td>  HTTP(S) socket write error  </td>
              </tr>
              <tr>
                <td>  719  </td>
                <td>  HTTP(S) socket closed  </td>
              </tr>
              <tr>
                <td>  720  </td>
                <td>  HTTP(S) data encode error  </td>
              </tr>
              <tr>
                <td>  721  </td>
                <td>  HTTP(S) data decode error  </td>
              </tr>
              <tr>
                <td>   722 </td>
                <td> HTTP(S) read timeout   </td>
              </tr>
              <tr>
                <td>  723  </td>
                <td>  HTTP(S) response failed  </td>
              </tr>
              <tr>
                <td> 724   </td>
                <td>  Incoming call busy  </td>
              </tr>
              <tr>
                <td>  725  </td>
                <td>  Voice call busy  </td>
              </tr>
              <tr>
                <td>  726  </td>
                <td>  Input timeout  </td>
              </tr>
              <tr>
                <td>  727  </td>
                <td>  Wait data timeout  </td>
              </tr>
              <tr>
                <td>  728  </td>
                <td>  Wait HTTP(S) response timeout  </td>
              </tr>
              <tr>
                <td>   729 </td>
                <td>  Memory allocation failed  </td>
              </tr>
              <tr>
                <td>  730  </td>
                <td>   Invalid parameter </td>
              </tr>
              <tr>
                <td>  995  </td>
                <td>   FOTA_INVALID_FILE (When FILE Type is different than the required one. e.g. APP FILE for IoT1/IoT2) </td>
              </tr>
              <tr>
                <td>  996  </td>
                <td>   FOTA File Size Exceed (When FOTA file size is higher than the MCU Flash Availability) </td>
              </tr>
              <tr>
                <td>  997  </td>
                <td>  FOTA Invalid Command (When Device receives a command for only installation) </td>
              </tr>
              <tr>
                <td>  998  </td>
                <td>  FOTA_SIZE_ERROR </td>
              </tr>
              <tr>
                <td>  999  </td>
                <td> FOTA_FLASH_WRITE_ERROR </td>
              </tr>
              <tr>
                <td>  1000  </td>
                <td>  FOTA_UNKNOWN_ERROR </td>
              </tr>

            </tbody>
          </table>
        </div>
      </Popup>
    </>
  );
};
export default HeaderComponent;
